/**
 * « Ajouter » d'une journée (17/10/2026) : un seul bouton dans l'en-tête de
 * chaque jour, à la place des 48 boutons invisibles par colonne. `compact`
 * (colonnes d'une semaine) : le pictogramme seul ; son nom dit toujours le jour.
 */
import type { ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../components/ui.js';

export function AddDayButton(props: { day: Date; onAdd: (day: Date) => void; compact?: boolean }): ReactNode {
  const day = props.day.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  return (
    <Button
      variant="ghost"
      icon={Boolean(props.compact)}
      className="planning-add"
      ariaLabel={`Ajouter au planning le ${day}`}
      onClick={() => props.onAdd(props.day)}
    >
      <Plus size={18} aria-hidden="true" />
      {props.compact ? null : <span>Ajouter</span>}
    </Button>
  );
}
